import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { FiatService } from "@main-services/currency";
import { filter } from "rxjs/operators";
import { UntilDestroy } from "@ngneat/until-destroy";
import { FiatWallet } from "@models";
import { Injectable } from "@angular/core";
import { GLOBAL_MIN_TRADE_AMOUNT_IN_EUR } from "@helpers/constants";
import { CashPlusPortfolioState } from "@modules/cashplus/+state/cashplus-portfolio.state.service";
import { CashplusPortfolioFacade } from "@modules/cashplus/+state/cashplus-portfolio.facade";

@UntilDestroy()
@Injectable({
	providedIn: "root"
})
export class UserFiatFundsService {
	private hasFiatBalance = false;
	private hasCashPlusFiatBalance = false;

	constructor(
		private readonly fiatwalletService: FiatWalletService,
		private readonly fiatService: FiatService,
		private cashPlusPortfolioFacade: CashplusPortfolioFacade
	) {
		// check fiat wallet list balance
		this.fiatWalletListStream$.subscribe({
			next: (fw) => {
				this.hasFiatBalance = this.checkIfFiatHasFund(fw);
			}
		});

		//check cash plus fiat wallet balance
		this.cashPlusPortfolio$.subscribe({
			next: (o) => {
				this.hasCashPlusFiatBalance = this.checkIfCashPlusHasBalance(o);
			}
		});
	}

	// Fiat wallet stream
	public fiatWalletListStream$ = this.fiatwalletService.getList().pipe(filter((d) => !!d.length));

	// Cash plus portfolio stream
	public cashPlusPortfolio$ = this.cashPlusPortfolioFacade.getPortfolioState$();

	// cash plus check helper
	public checkIfCashPlusHasBalance(assets: CashPlusPortfolioState): boolean {
		if (assets?.fiatConfigs) {
			return assets.fiatConfigs.some((d) => +d.asset_balance > GLOBAL_MIN_TRADE_AMOUNT_IN_EUR);
		}

		return false;
	}

	// fiat check helper
	public checkIfFiatHasFund(assets: FiatWallet[]): boolean {
		const list = assets.filter((f) => {
			const fiat = this.fiatService.getItemById(f.getFiatId());
			return !!fiat && f.getBalance() >= GLOBAL_MIN_TRADE_AMOUNT_IN_EUR * fiat.toEuroRate();
		});

		return !!list.length;
	}

	// return flag
	public hasFiatWalletsWithFunds(): boolean {
		return this.hasCashPlusFiatBalance || this.hasFiatBalance;
	}
}
